<sans-language-icon></sans-language-icon>
<!--<sans-theme-icon></sans-theme-icon>-->
<sans-leave-game-play [gamePlayId]="gamePlayId"></sans-leave-game-play>
